import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-dark-dark shadow-md">
      <div className="container-custom py-4">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center">
            <h1 className="text-2xl font-bold text-white tracking-wider">GAME PARK</h1>
          </Link>
          
          {/* Mobile menu button */}
          <button 
            className="md:hidden p-2 rounded-md text-gray-400 hover:text-white hover:bg-dark-light"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              {isMenuOpen 
                ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              }
            </svg>
          </button>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <Link to="/" className="text-white hover:text-primary font-medium border-b-2 border-primary">Home</Link>
            <Link to="/?filter=played" className="text-gray-300 hover:text-primary font-medium">Played</Link>
            <Link to="/?filter=new" className="text-gray-300 hover:text-primary font-medium">New</Link>
            <Link to="/?filter=trending" className="text-gray-300 hover:text-primary font-medium">Trending</Link>
          </nav>
        </div>
        
        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-2 space-y-2">
            <Link to="/" className="block py-2 px-4 text-white hover:bg-dark-light rounded">Home</Link>
            <Link to="/?filter=played" className="block py-2 px-4 text-gray-300 hover:bg-dark-light rounded">Played</Link>
            <Link to="/?filter=new" className="block py-2 px-4 text-gray-300 hover:bg-dark-light rounded">New</Link>
            <Link to="/?filter=trending" className="block py-2 px-4 text-gray-300 hover:bg-dark-light rounded">Trending</Link>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header; 